import styled from '@emotion/styled';

const ExpandTapper = styled.button`
  background: white;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  text-align: left;
  color: ${(props) => props.theme.colors.primary};
  border: none;
  outline: none;
  padding: 0 24px;

  img {
    width: 15px;
    margin-right: 12px;
  }
`;

export { ExpandTapper };
